// src/app/audit/AI/CoPilotV2/components/ChatInput.js

import React, { useState } from 'react';
import styled from 'styled-components';
import colors from 'styles/colors';

const ChatInput = ({ onSendMessage, disabled }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSendMessage(message);
      setMessage('');
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Type a message..."
        disabled={disabled}
      />
      <SendButton type="submit" disabled={disabled || !message.trim()}>
        Send
      </SendButton>
    </Form>
  );
};

const Form = styled.form`
  display: flex;
  gap: 12px;
`;

const Input = styled.input`
  flex: 1;
  padding: 12px;
  border: 1px solid ${colors.border};
  border-radius: 8px;
  
  &:disabled {
    background-color: ${colors.background.disabled};
  }
`;

const SendButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  background-color: ${colors.primary};
  color: white;
  border: none;
  cursor: pointer;
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default ChatInput;